import withDemoData from './withDemoData'
export default withDemoData
